<main>
  <header>
    <div class="stripes">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="bg"></div>
  </header>
</main>